(() => {
  if (customElements.get('kf-zodiac-finder')) return;
  class ZodiacFinder extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const form = this.querySelector('form');
      const month = form.elements.month;
      const day = form.elements.day;
      const lengths = [31,29,31,30,31,30,31,31,30,31,30,31];
      const result = this.querySelector('.kf-zodiac-result');
      const link = this.querySelector('.kf-zodiac-shop');
      month.addEventListener('change', () => {
        const previous = Number(day.value);
        day.replaceChildren(...Array.from({length:lengths[Number(month.value)-1]},(_,i) => new Option(String(i+1),String(i+1))));
        day.value = String(Math.min(previous,lengths[Number(month.value)-1]));
        result.textContent = ''; link.hidden = true;
      });
      day.addEventListener('change', () => {result.textContent='';link.hidden=true;});
      form.addEventListener('submit', event => {
        event.preventDefault();
        const m=Number(month.value), d=Number(day.value);
        if (m<1||m>12||d<1||d>lengths[m-1]) {result.textContent='Choose a valid month and day.';link.hidden=true;return;}
        const boundaries=[20,19,21,20,21,21,23,23,23,23,22,22];
        const signs=['Capricorn','Aquarius','Pisces','Aries','Taurus','Gemini','Cancer','Leo','Virgo','Libra','Scorpio','Sagittarius'];
        const sign=signs[d<boundaries[m-1]?m-1:m%12];
        result.textContent=`Their sign: ${sign}`;
        link.hidden=false;
      });
    }
  }
  customElements.define('kf-zodiac-finder',ZodiacFinder);
})();
